import { render } from "./9.DetailsStep.vue?vue&type=template&id=1698c1b4"
import script from "./9.DetailsStep.vue?vue&type=script&lang=js"
export * from "./9.DetailsStep.vue?vue&type=script&lang=js"

import "./9.DetailsStep.vue?vue&type=style&index=0&id=1698c1b4&lang=scss"

import exportComponent from "/Volumes/Samsung_T5/Work/Projects/my_projects/profiguide/profiguide/src/profiguide/static/web_plugin/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__